import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { useLogout } from '@/auth/api'
import { canAccessSurface } from '@/auth/surfaces'
import { Button } from '@/components/ui/button'
import { useAuth } from '@/contexts/use-auth'

export function Home() {
  const { t } = useTranslation()
  const { authUser } = useAuth()
  const logout = useLogout()

  const showModeration = canAccessSurface(authUser?.role, 'moderation')
  const showOperations = canAccessSurface(authUser?.role, 'operations')

  return (
    <main className="min-h-screen bg-background text-foreground flex flex-col items-center justify-center gap-8 p-6">
      <div className="flex flex-col items-center gap-2">
        <h1 className="text-4xl font-bold tracking-tight">{t('common.appName')}</h1>
        {authUser && (
          <p className="text-muted-foreground">{t('home.welcome', { email: authUser.email })}</p>
        )}
      </div>

      {showModeration && (
        <section className="flex flex-col items-center gap-3">
          <h2 className="text-sm font-semibold uppercase tracking-wide text-muted-foreground">
            {t('home.moderationSurface')}
          </h2>
          <nav className="flex flex-wrap items-center justify-center gap-3">
            <Button asChild type="button" variant="default">
              <Link to="/help-requests">{t('home.helpRequests')}</Link>
            </Button>
            <Button asChild type="button" variant="secondary">
              <Link to="/users">{t('home.users')}</Link>
            </Button>
            <Button asChild type="button" variant="secondary">
              <Link to="/moderation-actions">{t('home.moderationActions')}</Link>
            </Button>
          </nav>
        </section>
      )}

      {showOperations && (
        <section className="flex flex-col items-center gap-3">
          <h2 className="text-sm font-semibold uppercase tracking-wide text-muted-foreground">
            {t('home.operationsSurface')}
          </h2>
          <nav className="flex flex-wrap items-center justify-center gap-3">
            <Button asChild type="button" variant="default">
              <Link to="/audit">{t('home.audit')}</Link>
            </Button>
            <Button asChild type="button" variant="secondary">
              <Link to="/rate-limits">{t('home.rateLimits')}</Link>
            </Button>
            <Button asChild type="button" variant="secondary">
              <Link to="/maintenance">{t('home.maintenance')}</Link>
            </Button>
            <Button asChild type="button" variant="secondary">
              <Link to="/billing-reports">{t('home.billingReports')}</Link>
            </Button>
            <Button asChild type="button" variant="secondary">
              <Link to="/billing-settings">{t('home.billingSettings')}</Link>
            </Button>
          </nav>
        </section>
      )}

      <section className="flex flex-wrap items-center justify-center gap-3 border-t pt-6">
        <Button asChild type="button" variant="outline">
          <Link to="/account/password">{t('home.changePassword')}</Link>
        </Button>
        <Button
          type="button"
          variant="outline"
          onClick={() => logout.mutate()}
          disabled={logout.isPending}
        >
          {t('home.logout')}
        </Button>
      </section>
    </main>
  )
}
